export default "__VITE_ASSET__BietD8pU__"